import React, { useEffect, useState } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import { logEvent } from "./utils/logger";

// css
import "./App.css";
import "./assets/css/reset.css";
import "./assets/css/root.css";

// components
import Home from "./pages/home/Home.jsx";
import Footer from "./components/footer/index.jsx";
import { fetchProtectedData } from "./components/auth/index.jsx";
import { Title } from "./components/ui/index.jsx";
import AddWorkshops from "./pages/workshops/AddWorkshops.jsx";
import NavBar from "./components/bar/navBar.jsx";
import ManageWorkshops from "./pages/workshops/ManageWorkshops.jsx";
import AddPartners from "./pages/partners/AddPartners.jsx";
import ManagePartners from "./pages/partners/ManagePartners.jsx";
import AddCalendar from "./pages/calendar/AddCalendar.jsx";
import ManageCalendar from "./pages/calendar/ManageCalendar.jsx";
import AddPhotos from "./pages/photos/AddPhotos.jsx";
import ManagePhotos from "./pages/photos/ManagePhotos.jsx";
import ScrollToTop from "./functions/scrollToTop.js";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProtectedData().then((data) => {
      if (data) {
        setLoading(false);
        logEvent("INFO", "AUTH", "Admin session restored", {
          uid: data.uid,
          email: data.email,
          displayName: data.displayName,
        });
      } else {
        setLoading(true);
        logEvent("WARN", "AUTH", "No valid session, redirecting to login");
        window.location.href =
          "//auth.loukaaa.com/signin?url=" + window.location.origin;
      }
    });
  }, []);

  const router = createBrowserRouter([
    {
      // errorElement: <ErrorPage />,
      path: "/",
      element: (
        <>
          <ScrollToTop />
          <Home />
          <Footer />
        </>
      ),
    },
    {
      // errorElement: <ErrorPage />,
      path: "/",
      element: (
        <>
          <NavBar link="/" title="Administration" />
          <ScrollToTop />
          <Outlet />
          <Footer />
        </>
      ),
      children: [
        {
          path: "/workshops",
          children: [
            {
              path: "add",
              element: <AddWorkshops />,
            },
            {
              path: "edit/:id",
              element: <AddWorkshops />,
            },
            {
              path: "manage",
              element: <ManageWorkshops />,
            },
          ],
        },
        {
          path: "/partners",
          children: [
            {
              path: "add",
              element: <AddPartners />,
            },
            {
              path: "edit/:id",
              element: <AddPartners />,
            },
            {
              path: "manage",
              element: <ManagePartners />,
            },
          ],
        },
        {
          path: "/calendar",
          children: [
            {
              path: "add",
              element: <AddCalendar />,
            },
            {
              path: "edit/:id",
              element: <AddCalendar />,
            },
            {
              path: "manage",
              element: <ManageCalendar />,
            },
          ],
        },
        {
          path: "/photos",
          children: [
            {
              path: "add",
              element: <AddPhotos />,
            },
            {
              path: "manage",
              element: <ManagePhotos />,
            },
          ],
        },
      ],
    },
  ]);
  return (
    <div className="App">
      {loading ? (
        <>
          <div className="loading">
            <Title level="h4">admin.lecrin-sauvage.fr</Title>
          </div>
        </>
      ) : (
        <RouterProvider router={router} />
      )}
    </div>
  );
}

export default App;
